/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';

import { InputBaseComponentProps } from '@mui/material/InputBase';
import { useTheme } from '@mui/material/styles';

const StripeInputField = React.forwardRef<any, InputBaseComponentProps>(
  function StripeInputField(props, ref) {
    const { component: Component, options, placeholder, ...other } = props;
    const theme = useTheme();
    const [mountNode, setMountNode] = React.useState<any | null>(null);

    React.useImperativeHandle(
      ref,
      () => ({
        focus: () => mountNode.focus(),
      }),
      [mountNode],
    );

    return (
      <Component
        onReady={setMountNode}
        options={{
          ...options,
          placeholder: placeholder,
          style: {
            base: {
              fontSize: '14px',
              lineHeight: '16px',
              fontFamily: theme.typography.fontFamily,
              color: theme.palette.black.dark,
              '::placeholder': {
                color: theme.palette.light.placeholder,
              },
            },
            invalid: {
              color: theme.palette.text.primary,
            },
          },
        }}
        {...other}
      />
    );
  },
);

export default StripeInputField;
